import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n";
import classNames from "classnames";
import React from "react";
import { ChipTagGroup } from "../../../../chip/presets/ChipTagGroup/ChipTagGroup";
import { ITagGroup } from "../../../../../models/tagGroups/TagGroupStore";
import settingsStyles from "../../../../../styles/settings.css";
import sharedStyles from "../../ManualAssignmentSettings.css";
interface Props {
  onChange: (tagGroup: ITagGroup) => void;
  optionsItemProvider: () => ITagGroup[];
  isEditing: boolean;
  tagGroupName: string;
  enabled: boolean;
  hasError: boolean | undefined;
}
export const TagGroupColumn = ({
  optionsItemProvider,
  onChange,
  isEditing,
  tagGroupName,
  enabled,
  hasError
}: Props) => {
  return (
    <div className={settingsStyles["input-width"]}>
      <p className={classNames(settingsStyles["form-label-font"], sharedStyles["label-margin"])}>
        {intl.formatMessage("settings.assignmentRules.manualAssignment.form.tagGroup.label")}
      </p>
      {isEditing ? (
        <AutoComplete<ITagGroup>
          onChange={onChange}
          itemsProvider={optionsItemProvider}
          itemToString={(val) => (val ? val.name : "")}
          placeholder={intl.formatMessage(
            "settings.assignmentRules.manualAssignment.form.tagGroup.label"
          )}
          readOnly
          emptyPlaceholder={intl.formatMessage(
            "settings.assignmentRules.manualAssignment.form.tagGroup.empty"
          )}
          className={classNames(settingsStyles["input-width"])}
          hasError={hasError}
        />
      ) : (
        <ChipTagGroup name={tagGroupName} enabled={enabled} />
      )}
    </div>
  );
};
